import { Button, Input } from '@fluentui/react-components';
import { DismissRegular, SearchRegular } from '@fluentui/react-icons';
import { memo, useEffect, useRef } from 'react';
import type { IQueryListRouteApiProps } from '../QueryListRouteApi';
import type { TListSearchSchema } from './list-search-schema';

export const ListSearch = memo<IQueryListRouteApiProps>((props) => {
    const navigate = props.routeApi.useNavigate();
    const setSearch = (search?: string): void => {
        navigate({
            search: (prevSearch: Record<string, any>) =>
                Object.assign(Object.assign({}, prevSearch), { search }),
        });
    };

    const inputRef = useRef<HTMLInputElement>(null);
    const search = props.routeApi.useSearch({
        select: (state: Pick<TListSearchSchema, 'search'>) => state.search || '',
    });

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.value = search;
        }
    }, [search]);

    return (
        <Input
            aria-label="Suche"
            contentAfter={
                <Button
                    appearance="transparent"
                    aria-label="Suche zurücksetzen"
                    icon={<DismissRegular />}
                    onClick={() => setSearch()}
                    size="small"
                />
            }
            contentBefore={<SearchRegular />}
            defaultValue={search}
            onKeyUp={(event) => {
                switch (event.key) {
                    case 'Enter':
                        setSearch(event.currentTarget.value.trim() || undefined);
                        break;
                    case 'Escape':
                        event.currentTarget.value = search;
                        break;
                }
            }}
            placeholder="Suche"
            ref={inputRef}
            required
            role="search"
        />
    );
});
ListSearch.displayName = 'ListSearch';
